import { createBrowserRouter } from "react-router-dom";
import React, { MutableRefObject } from "react";
import { OrderRoutes } from "./blocks/route-components/order.routes";
import {
  AccountActivationRoute,
  ChangePasswordRoute,
  LoginRoute,
  PasswordRecoverRoute,
  RegisterRoute,
} from "./blocks/route-components/auth.routes";
import { WarehouseWorkerRoutes } from "./blocks/route-components/warehouse-worker.routes";
import { UserRoutes } from "./blocks/route-components/user.routes";
import { LanguageRouteComponent } from "./blocks/route-components/languageRouteComponent";
import { InitialRoute } from "./blocks/route-components/initial.route";
import { InfoRoutes } from "./blocks/route-components/info.routes";
import RouteError from "../pages/info/route-error";
import { AdminRoutes } from "./blocks/route-components/admin.routes";
import { LocalWarehouseWorkerRoutes } from "./blocks/route-components/local-warehouse-worker.routes";
import About from "../pages/about";
import BlogList from "../pages/blog/List";
import BlogSingle from "../pages/blog/Single";
import OnlineStores from "../pages/online-stores/OnlineStores";

export const router = createBrowserRouter([
  InitialRoute,
  {
    path: "/:language/",
    errorElement: <RouteError />,
    Component: () => <LanguageRouteComponent />,
    children: [
      LoginRoute,
      RegisterRoute,
      PasswordRecoverRoute,
      ChangePasswordRoute,
      AccountActivationRoute,
      OrderRoutes,
      WarehouseWorkerRoutes,
      AdminRoutes,
      UserRoutes,
      InfoRoutes,
      LocalWarehouseWorkerRoutes,
    ],
  },
  {
    path: "/:language/about-us",
    errorElement: <RouteError />,
    Component: () => <About />,
  },
  {
    path: "/:language/blog",
    errorElement: <RouteError />,
    Component: () => <BlogList />
  },
  {
    path: "/:language/blog/:slug",
    errorElement: <RouteError />,
    Component: () => <BlogSingle />
  },
  {
    path: "/:language/online-stores",
    errorElement: <RouteError />,
    Component: () => <OnlineStores />
  }
]);

export interface OutletContext {
  hasValidatedRecipient: boolean;
  mainContentContainerRef: MutableRefObject<HTMLElement | null>;
  isAdmin: boolean;
  isPdr: boolean;
  isWarehouseWorker: boolean;
  isLocalWarehouseWorker: boolean;
}

export enum UserGroups {
  ADMIN = 1,
  WAREHOUSE_WORKER = 2,
  BAREKAM = 3,
  LOCAL_WAREHOUSE_WORKER = 4,
  PARCEL_DELIVERY_REQUEST = 5
}
